<template>
  <mk-drawer
    :visible="visible"
    direction="rtl"
    :show-close="false"
    size="520px"
    class="member-statistics-detail"
    :hide-header="true"
    @close="cancel"
  >
    <div class="header">
      <h3>记录明细</h3>
      <i
        class="close iconfont icon-mk-guanbi"
        @click="cancel"
      ></i>
    </div>
    <div class="tabs">
      <mk-tabs
        v-model="activeName"
        calss="el-tabs-mk-ui-mini"
      >
        <mk-tab-pane
          label="员工分享"
          name="first"
        />
        <mk-tab-pane
          label="用户转发"
          name="second"
        />
      </mk-tabs>
    </div>
    <div class="tips">
      <span class="txt">共计 {{ totalMen }} 名{{ activeName === 'first' ? '员工分享' : '用户转发' }}，{{ activeName === 'first' ? '分享 ' + totalShare : '转发 ' + totalShare }} 次</span>
      <search-select-member
        :key="key"
        v-model="member"
        :type="type"
        :config="config"
        :placeholder="placeholder"
        @change="change"
      />
    </div>
    <div class="list">
      <template v-if="list && list.length > 0">
        <div
          v-for="(item,index) in list.slice(0,10)"
          :key="index"
          class="list-item"
        >
          <div class="list-item-avatar">
            <img
              v-if="item.avatar"
              :src="item.avatar"
            >
            <img
              v-else
              class="avatarUrl"
              src="@/assets/images/user.png"
            >
          </div>
          <div class="list-item-name">
            <div class="name">
              {{ item.name }}
              <mk-popover
                v-if="activeName !=='first' && item.isSyncWPContact"
                placement="top-start"
                title=""
                width="60"
                trigger="hover"
                content="已被添加为微信好友"
                popper-class="wx-icon-popover"
              >
                <ds-iconfont
                  slot="reference"
                  class="wx-icon"
                  icon-class="iconweixinguanli"
                  style="cursor: pointer; font-size: 18px;"
                />
              </mk-popover>
            </div>
            <div class="view">
              <span class="pv">浏览量：{{ item.pv }}</span>
              <span class="uv">浏览人数：{{ item.uv }}</span>
            </div>
          </div>
          <div class="share-time">
            <div class="txt">
              {{ activeName === 'first' ? (item.scene === 'friend' ? '分享给好友' : '分享到朋友圈') : (item.scene === 'friend' ? '转发给好友' : '转发到朋友圈') }}
            </div>
            <div class="time">
              {{ item.shareTime }}
            </div>
          </div>
          <!-- <div
            v-if="activeName !=='first' && item.clueStatus === 0"
            class="clue"
          >
            线索
          </div> -->
          <!-- <div
            v-if="activeName !=='first' && item.isSyncWPContact"
            class="wechat"
          >
            微信好友
          </div> -->
        </div>
      </template>
      <no-data v-else />
      <!-- clueStatus 0：线索 2：客户 -->
    </div>
    <mk-pagination
      v-if="list && list.length > 0"
      class="page"
      layout="total, prev, pager, next"
      :total="total"
      :current-page="page"
      @current-change="currentChange"
    />
  </mk-drawer>
</template>
<script>
import searchSelectMember from '@components/search-select-member'
import noData from '@components/no-data'
export default {
  name: 'MemberStatisticsDetail',
  components: {
    searchSelectMember,
    noData
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    baseData: {
      type: [Object, Array],
      default () {
        return {}
      }
    },
    initActiveName: {
      type: String,
      default: 'first'
    }
  },
  data () {
    return {
      activeName: 'first',
      member: '',
      key: Number(new Date().getTime()) + '_acive',
      list: [],
      total: 0,
      page: 1,
      totalMen: 0,
      totalShare: 0
    }
  },
  computed: {
    type () {
      if (this.activeName === 'first') {
        return 'sale'
      } else {
        return 'clue'
      }
    },
    config () {
      if (this.activeName === 'first') {
        return {
          id: 'userId',
          name: 'name'
        }
      } else {
        return {
          id: 'unionId',
          name: 'nickName'
        }
      }
    },
    placeholder () {
      if (this.activeName === 'first') {
        return '输入员工名搜索'
      } else {
        return '输入用户昵称搜索'
      }
    }
  },
  watch: {
    activeName () {
      this.member = ''
      this.page = 1
      this.key = Number(new Date().getTime()) + '_acive'
      this.bridgeMaterialStatisticsDetailPost()
    }
  },
  created () {
    this.activeName = this.initActiveName
    this.bridgeMaterialStatisticsDetailPost()
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    async bridgeMaterialStatisticsDetailPost () {
      let metas = {}
      if (this.member !== '') {
        this.activeName === 'first' ? metas.userId = this.member : metas.unionId = this.member
      }
      const res = await MKMATERIALSVC.MaterialApi.bridgeMaterialStatisticsDetailPost({
        materialId: this.$route.query.id,
        page: this.page,
        pageSize: 10,
        type: this.activeName === 'first' ? 'sale' : 'clue',
        ...metas
      })
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
        this.totalShare = res.data.totalShare
        this.totalMen = res.data.totalMen
        // this.list = [
        //   {
        //     avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/MzfKJP8K6qQKMSnGLAANgqNQ9EwTsRztxOQXfich12ZictiaicDM82uwnZDstB6k6h9vlGEJOS1pbXFATibdZlwAGmA/132',
        //     clueStatus: 1,
        //     countShare: 999,
        //     name: '七米海岸i',
        //     pv: 222,
        //     uv: 333,
        //     scene: 'friend',
        //     shareTime: '2020-05-16 12:00:12'
        //   },
        //   {
        //     avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/d76BPzia8ad1Y9r17esD11MGfgecJDhb0jLcY4O3eYtYht0smJfWHYGbh1icGGyPvxn7ETtB36tvmUdiaUTrRJMQA/132',
        //     clueStatus: 2,
        //     countShare: 888,
        //     name: 'Mitch Conner',
        //     pv: 555,
        //     uv: 666,
        //     scene: 'circle',
        //     shareTime: '2020-05-16 22:22:12'
        //   }
        // ]

        // this.list = this.list.concat(this.list)
        // this.list = this.list.concat(this.list)
        // this.list = this.list.concat(this.list)
        // this.total = 100000
      } else {
        this.list = []
        this.total = 0
      }
    },
    showVisible () {
      this.visible = true
    },
    currentChange (e) {
      this.page = e
      this.bridgeMaterialStatisticsDetailPost()
    },
    change () {
      this.page = 1
      this.bridgeMaterialStatisticsDetailPost()
    }
  }
}
</script>
<style lang="scss" scoped>
.member-statistics-detail {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .header {
    height: 60px;
    line-height: 60px;
    box-shadow: 0 1px 0 0 #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;

    h3 {
      // font-weight: 500;
      font-weight: 500;
      font-size: 16px;
      margin-left: 20px;
    }

    .close {
      font-size: 16px;
      cursor: pointer;
      margin-right: 20px;
      color: #bfbfbf;
    }
  }

  .tabs {
    border-bottom: 1px solid #d9d9d9;
    padding: 0 20px;
    flex-shrink: 0;

    /deep/ .el-tabs__nav-scroll {
      padding: 0 !important;

      .el-tabs__item {
        font-size: 13px !important;
        height: 40px !important;
        line-height: 40px !important;
        font-weight: 500 !important;
        outline: none !important;
        padding: 0 10px !important;
      }

      .el-tabs__item.is-active {
        color: #009cff !important;
      }

      .el-tabs__active-bar {
        // height: 1px !important;
        background: #009cff !important;
      }
    }
  }

  .tips {
    width: 100%;
    padding: 0 20px;
    flex-shrink: 0;

    .txt {
      display: block;
      line-height: 18px;
      padding: 9px 0;
      font-size: 13px;
      color: #595959;
    }
  }

  .list {
    // width: calc(100% - 40px);
    height: calc(100vh - 234px);
    overflow-y: auto;
    // margin: 0 auto;

    .list-item {
      width: calc(100% - 40px);
      margin: 0 auto;
      padding: 10px 0;
      // border-bottom: 1px solid #d9d9d9;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      position: relative;

      .list-item-avatar {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
        }
      }

      .list-item-name {
        margin-left: 12px;

        .name {
          font-size: 13px;
          line-height: 18px;
          color: #262626;
          // font-weight: 500;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .view {
          color: #999;
          font-size: 13px;
          line-height: 18px;

          .pv {
            margin-right: 4px;
          }
        }
      }

      .share-time {
        margin-left: 60px;
        font-size: 13px;
        line-height: 18px;
        color: #888;

        .txt {
          margin-bottom: 4px;
        }
      }

      .wechat,
      .clue {
        position: absolute;
        bottom: 10px;
        right: 0;
        font-size: 13px;
        line-height: 13px;
        padding: 4px 12px;
        background: #d7d7d7;
        color: #595959;
        border-radius: 2px;
      }

      .wechat {
        background: #facd91;
      }
    }
  }

  /deep/ .no-data {
    margin-top: 0 !important;
    padding-top: 64px;
  }

  .wx-icon {
    color: #d9d9d9;

    &:hover {
      color: #009cff;
    }
  }
}
</style>
<style lang="scss">
  .wx-icon-popover {
    padding: 10px !important;
    width: auto !important;
    min-width: auto !important;
    font-size: 12px;
  }
</style>
